<template>
    <div>
        <slot name="title">
          <div class="content-left">
              <h4> Update your billing information </h4>
          </div>
        </slot>
        <div class="row">
            <slot name="header">
              <div class="col-xl-12 col-xs-12" v-if="user_card">
                  <div class="card-content info_content">
                      <img src="@/assets/info-icon.svg"  class="icon" width="20" height="20"/>
                      Your are currently paying with a <span class="bold">{{user_card.card.brand}}</span> ending in
                      <span class="bold">{{user_card.card.last4}}</span>
                  </div>
              </div>
            </slot>
            <slot name="card">
              <card class='stripe-card col-xs-l-12'
                  :class='{ complete }'
                  :ref="type"
                  stripe='pk_test_K6qRDvTaGGSr74rJaPTpsFHa00mXwGfu5M'
                  :options='stripeOptions'
                  @change='complete = $event.complete'
                  v-if="process === 'development'"
              />
              <card class='stripe-card col-xs-l-12'
                  :class='{ complete }'
                  :ref="type"
                  stripe='pk_live_JbUaKreMSUKqxoD5NUNR92bA00QwmtDfdT'
                  :options='stripeOptions'
                  @change='complete = $event.complete'
                  v-if="process=== 'production'"
              />
            </slot>
            <slot name="info">
              <div class="col-xl-12 col-xs-12 stripe-info">
                  <flash-message class="large"></flash-message>
                  <img src="@/assets/shield-lock.svg"  class="icon" width="20" height="20"/>
                  <label class="w-form-label">
                      Your credit card information is securely handled by
                      <a href="https://stripe.com" target="_blank" class="stripe-link">Stripe</a>
                  </label>
              </div>
            </slot>
            <slot name="button">
              <div>
                <input type="checkbox"  id="agreementCheckbox"  required>
                <label for="agreementCheckbox">I agree to Orbitly.io's <a href="https://www.orbitly.io/terms-and-conditions" target="_blank">Terms of Service</a> and <a href="https://www.orbitly.io/privacy-policy" target="_blank">Policy</a>. </label>
              </div>
              <div class="col-xl-12 col-xs-12">
                  <button class="btn large bold" @click="update"
                          :disabled="desable_button"> {{button_value}} </button>
              </div>
            </slot>
            <!-- <slot name="footer">
              <div class="col-xl-12 col-xs-12">
                  <div class="form-medium-content">
                      <img src="@/assets/info-icon.svg"  class="icon" width="20" height="20"/>
                      <label class="w-form-label">
                          By submitting this form you authorize the use of this card to purchase Orbitly enrichment credits and agree to our <a href="https://www.orbitly.io/terms-of-service/july-12-2018" target="_blank"> Terms and Conditions. </a>
                      </label>
                  </div>
              </div>
            </slot> -->
        </div>
    </div>
</template>

<script>

import { Card, createToken } from 'vue-stripe-elements-plus'
import { mapMutations } from 'vuex'

export default {
  name: 'billing',
  components: { Card },
  mounted () {
    this.messageStorage.destroyAll()
    this.reset_button()
  },
  props: ['type'],
  beforeDestroy () {
    if (this.type === 'card') {
      this.$refs.card.$destroy()
    } else if (this.type === 'modal') {
      this.$refs.modal.$destroy()
    }
  },
  data () {
    return {
      desable_button: false,
      process: process.env.NODE_ENV,
      button_value: 'Update billing',
      messageStorage: this.flash(),
      stripePublishableKey: 'pk_test_K6qRDvTaGGSr74rJaPTpsFHa00mXwGfu5M',
      complete: false,
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
      }
    }
  },
  methods: {
    ...mapMutations([
      'user/setAuthUser',
      'uploadedLeadList/modalState'

    ]),
    reset_button () {
      this.desable_button = false
      if (this.type === 'modal') {
        this.button_value = 'Buy credits'
      } else {
        this.button_value = 'Update billing'
      }
    },
    update: function () {
      if(agreementCheckbox.checked === false) return false;
      this.desable_button = false
      this.button_value = 'Updating...'
      this.stripeCheck = true
      createToken().then(response => {
        if (response.error) {
          this.stripeCheck = false
          this.messageStorage.destroyAll()
          this.messageStorage.flash(response.error.message, 'error')
          // eslint-disable-next-line
          this.reset_button()
          console.error(response)
        } else {
          var data = {
            'stripe_token_id': response.token.id,
            'stripe_token_obj': JSON.stringify(response.token)
          }
          this.$http.post('/api/billing/update_cc', data).then((res) => {
            this.messageStorage.destroyAll()
            this.messageStorage.flash('Your card information has been updated', 'success')
            this['user/setAuthUser'](res.data)
            if (this.type === 'modal') {
              this.$emit('update')
              this['uploadedLeadList/modalState'](true)
              this.button_value = 'Buying credits...'
            } else {
              this.reset_button()
            }
          }).catch((err) => {
            console.log(err)
            this.messageStorage.destroyAll()
            // this.messageStorage.flash('Please try again', 'error')
            this.messageStorage.flash(err.data.error, 'error')
            this.reset_button()
          })
        }
      })
    }
  },
  computed: {
    user_card: function () {
      return this.$store.state.user.data.stripe_obj
    }
  }
}
</script>
